"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[893],{

/***/ 5527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileHeader": function() { return /* binding */ GarageProfileHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _App_public_assets_images_repareo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6447);
/* harmony import */ var _App_components_common_HeaderNavigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8427);
/* harmony import */ var _App_components_Home_ContentElements_PartnerHeaderLogos_AdacPartnerLogo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2296);
/* harmony import */ var _App_components_Home_ContentElements_PartnerHeaderLogos_MerhmarkencenterLogo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7183);






var GarageProfileHeader = function(param) {
    var partner = param.partner;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: "garageProfileHeader col-span-full text-gray-700 bg-white top-0 z-20 lg:max-w-[928px] lx:max-w-screen-lgplus my-0 mx-6 md:mx-12 lg:mx-auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_App_components_common_HeaderNavigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "garageProfileHeader__bottom grid grid-cols-12 items-center py-4 lg:py-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "repareoIcon col-span-6 flex justify-start flex-1 items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: "https://www.repareo.de",
                                title: "repareo.de Werkstattvergleich und Werkstattportal",
                                className: "z-20 ".concat(partner.partnerLogoFirst ? "order-1 hidden xl:flex" : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "repareo"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("picture", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            loading: "lazy",
                                            src: _App_public_assets_images_repareo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                            width: "136",
                                            height: "35",
                                            alt: "repareo.de Werkstattvergleich und Werkstattportal"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-38 ".concat(partner.partnerLogoFirst ? "pr-10" : "pl-10 hidden xl:flex"),
                                children: [
                                    partner.partnerLogo == "adacPartnerLogo" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_App_components_Home_ContentElements_PartnerHeaderLogos_AdacPartnerLogo__WEBPACK_IMPORTED_MODULE_4__/* .AdacPartnerLogo */ .e, {}),
                                    partner.partnerLogo == "mehrmarkencenterPartnerLogo" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_App_components_Home_ContentElements_PartnerHeaderLogos_MerhmarkencenterLogo__WEBPACK_IMPORTED_MODULE_5__/* .MehrmarkencenterLogo */ ._, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "telContainer col-span-6 flex justify-end items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mr-8 md:mr-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "tel:+4989244182010",
                                        className: "decoration-0 no-underline flex justify-end items-center rounded-md bg-blue-50 px-3 py-2 sm:p-0 sm:bg-white sm:text-gray-700 text-base leading-6 font-medium",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fa-kit fa-phone fa-fw text-primary text-regular mr-2 inline-block align-middle"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "hidden sm:block",
                                                children: "+49 89 244 182 010"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-sm leading-4 font-medium text-primary-700 sm:hidden",
                                                children: "Anrufen"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "hidden sm:inline-block text-gray-500 text-sm leading-none font-normal",
                                        children: "8 - 20 Uhr | Montag - Samstag"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "nav-toggle-subPage nav-open col-span-1",
                                href: "#nav-open",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Open menu"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fa-kit fa-bars fa-fw text-gray-900 text-3xl pl-2'}"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "nav-toggle-subPage nav-closed col-span-1",
                                href: "#nav-closed",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "Close menu"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fa-kit fa-xmark fa-fw text-gray-900 text-3xl pl-2"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

}]);